<template>
  <div class="wrap">
    <div class="container lnb">
      <div class="contents_wrap">
        <div class="contents">
          <div class="title">
            {{ title }}
            <el-button class="title_btn" type="primary" size="" @click="addBtn()">등록</el-button>
            <div class="clear"></div>
          </div>
          <div class="table_wrap">
            <div class="table_search">
              <el-row>
                <el-col :span="12">
                  <span class="t_s_title">분류</span>
                  <el-select
                    v-model="categorySelected"
                    placeholder="Select"
                    class="table_s_select"
                  >
                    <el-option
                      value=""
                      key=""
                      label="전체"
                    >
                    </el-option>
                    <el-option
                      v-for="item in categoryData"
                      :key="item.fc_idx"
                      :label="item.fc_category"
                      :value="item.fc_idx">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="12">
                  <span class="t_s_title">검색</span>
                  <el-select
                    v-model="tableSelected"
                    placeholder="Select"
                    class="table_s_select"
                  >
                    <el-option
                      v-for="item in tableSelectOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-input class="table_s_input"
                            v-model="tableSearch"
                            size=""
                            placeholder="검색어를 입력해주세요."
                            @keyup.enter.native="[getList(), page=1]"
                  />
                </el-col>
              </el-row>
            </div>
            <div class="search_btn_wrap text_center">
              <el-button type="primary" @click="[getList(), page=1]">검색</el-button>
            </div>
            <el-table
              :data="tableData"
              style="width: 100%"
              empty-text="데이터가 없습니다."
            >
              <el-table-column
                class="table_no"
                type="index"
                label="번호"
                width="100"
                class-name="num"
                :index="tableIndex"
              >
              </el-table-column>
              <el-table-column v-for="header in tableHeader" :key="header.prop"
                               :label = header.label
                               :prop = header.prop
                               :width = header.width
                               :class-name = header.prop
              ></el-table-column>
              <el-table-column v-if="tableoption"
                               align="right"
                               width="200"
                               label="옵션"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="handleEdit(scope.$index, scope.row)">수정</el-button>
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)">삭제</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagnation_wrap" v-show="filterPagnation.total">
            <el-pagination
              :page-size = filterPagnation.size
              :pager-count = filterPagnation.pagerCount
              layout="prev, pager, next"
              :current-page.sync = page
              :total="listTotal"
              @current-change="getList"
            >
            </el-pagination>
          </div>
        </div>
        <page-footer></page-footer>
      </div>
    </div>
  </div>
</template>

<script>
  import VuxAlert from '@/mixins/vux-alert';
  import util from '@/mixins/util';
  import sessionStorage from '@/mixins/sessionStorage';
  import {countryList} from "@/service/countryService";

  let params ={};
  export default {
    name: "Faq",
    components: {},
    mixins: [ VuxAlert,sessionStorage ],
    data(){
      return{
        userInfo : this.getUserInfo(),
        c_idx : 1,
        l_idx: 1,
        data : {},
        title: this.$route.meta.title,
        tableData: [],
        orgTableData : [],
        categoryData : [],
        tableSearch: '',
        tableHeader: [
          {
            label : '분류',
            prop : 'category',
            width: '300'
          },
          {
            label : '제목',
            prop : 'fa_subject'
          },
          {
            label: '등록일',
            prop: 'created_at',
            width: '200'
          },{
            label: '수정일',
            prop: 'updated_at',
            width: '200'
          }
        ],
        tableoption: true,
        pagnation: {
          size: 10,
          pagerCount: 11,
          page: 1,
        },
        page : 1,
        listTotal : 0,
        tableSelected: '',
        categorySelected : '',
        tableSelectOption: [
          {
            label: '제목',
            value: 'su'
          }
        ],
        category : []
      }
    },
    computed: {
      tableFilter() {
        return this.tableData
      },
      filterPagnation() {
        return {
          size: 10,
          pagerCount: 11,
          total: this.tableFilter.length,
          page: 1
        }
      }
    },
    mounted() {
      this.getCountryList();
      this.getCategoryList();
    },

    methods: {
      getCountryList(){
        this.$api.$user.getLanguage()
          .then(res => { // 로그인 api 통신 후 결과 처리
            //let resultData = res.Data.result;
            // this.category = [{c_idx : 1 , CO_NAME_KOR : 'South Korea'},{c_idx : 2 , CO_NAME_KOR : 'Japan'}];
            this.category = res.Data.Result.List;
          });
      },
      addBtn(){
        this.$router.push('/board/faq/detail');
      },
      resetPage() {
        this.page = 1
      },

      getCategoryList(){
        params = {
          page: this.page,
          c_idx : this.c_idx,
        }
        /*if(this.userInfo.g_idx === 2){
          params.c_idx = this.userInfo.c_idx;
        }else{
          if(this.c_idx){
            params.c_idx = this.c_idx;
          }
        }*/
        /*if(this.l_idx != '') {
          params.lid = this.l_idx;
        }*/
        this.$api.$board.getFaqCategory(params).then( res => res.Data.Result).then(res => {
          if(res.Info.Type === 1) {
            this.categoryData = res.List;
          }else{
            this.categoryData = [];
          }
        })
        this.getList();
      },

      async getList() {
        params = {
          page: this.page,
          ip : 1
        }

        /*if(this.userInfo.g_idx === 2){
          params.c_idx = this.userInfo.c_idx;
        }else{
          if(this.c_idx){
            params.c_idx = this.c_idx;
          }

        }*/
        if(this.tableSearch != '') {
          params[this.tableSelected] = this.tableSearch
        }
        if(this.categorySelected != ''){
          params.fc = this.categorySelected;
        }
        if(this.l_idx != '') {
          params.lid = this.l_idx;
        }

        await this.$api.$board.getFaq(params).then( res => res.Data.Result).then(res => {
          if(res.Info.Type === 1) {
            this.tableData = res.List;
            util.each(this.tableData, (item, index, allItems) => {
              util.each(this.categoryData, (category, index2, allItems2) => {
                if(item.fc_idx == category.fc_idx){
                  item.category = category.fc_category;
                }
              });
            });
            this.lastPage = res.Page.last_page;
            this.listTotal = res.Page.total;
          }else{
            this.tableData = [];
            this.page = 1;
            this.lastPage = 0;
            this.listTotal = 0;
          }
        })
      },
      handleEdit(index, row) {
        this.$router.push('/board/faq/detail/'+row.fa_idx);
      },

      handleDelete(index, row) {
        let alertParams = {'element' : this , 'key' : row.fa_idx };
        this.listDeleteAlert(alertParams);

      },
      dataDelete(key){
        let params = {'fa_idx' : key}
        this.$api.$board.deleteFaq(params).then( res => res.Data.Result).then(res => {
          if(res.Info.Type === 1) {
            this.page = 1
            let alertParams = {'element' : this  };
            this.deleteAlert(alertParams);
          }else{
            this.errorAlert(res.reason);
          }
        })
      },

      /*      CategoryChange() {
              this.tableSearch = '';
              if(this.categorySelected ){
                this.tableData = this.$_.filter(this.orgTableData, this.$_.iteratee({ fc_idx: this.categorySelected }));
              }else{
                this.tableData = this.orgTableData;
              }

            },*/
      tableIndex(index) {
        return index + this.pagnation.size * (this.page - 1) +1
      },
    }
  }
</script>
<style>

</style>
